// Smart duration parsing (Project Plan 365 style).
//
// Accepts strings like:
//   "3"     -> 3 working days
//   "3d"    -> 3 working days
//   "3.5"   -> 3.5 working days
//   "3h"    -> 3 / 8 = 0.375 working days
//   "24h"   -> 24 / 8 = 3 working days
//   "0.5d"  -> 0.5 working days
//   "2 days", "4 hours" — long form also tolerated
//
// Storage: always float working-days (1.0 = one full working day at 8h/day).
//          The UI re-formats < 1 day values as hours for clarity.

export const WORKING_HOURS_PER_DAY = 8;

const NUM_RE = /^\s*([0-9]*\.?[0-9]+)\s*([a-zA-Z]*)\s*$/;

/**
 * Parse "3h" / "3d" / "3.5" into float working-days.
 * Returns null on invalid input.
 */
export function parseDuration(input) {
  if (input === null || input === undefined) return null;
  if (typeof input === "number") return input > 0 ? input : null;
  const m = String(input).match(NUM_RE);
  if (!m) return null;
  const value = parseFloat(m[1]);
  if (!Number.isFinite(value) || value <= 0) return null;
  const unit = (m[2] || "d").toLowerCase();
  // Accept: d, day, days, h, hr, hour, hours
  if (unit.startsWith("h")) return value / WORKING_HOURS_PER_DAY;
  if (unit === "" || unit.startsWith("d")) return value;
  return null;
}

/**
 * Format a float working-days duration for display.
 *  - < 1 day  -> hours ("4h", "3.5h")
 *  - == whole -> days  ("3d")
 *  - else     -> days with one decimal ("1.5d")
 */
export function formatDuration(days) {
  if (days === null || days === undefined || !Number.isFinite(days)) return "";
  if (days < 1) {
    const h = days * WORKING_HOURS_PER_DAY;
    // Trim trailing .0
    return `${Math.round(h * 10) / 10}h`;
  }
  if (Math.abs(days - Math.round(days)) < 0.01) return `${Math.round(days)}d`;
  return `${Math.round(days * 10) / 10}d`;
}
